/*eslint-disable no-magic-numbers*/
export const layerVectorCustomization = [
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "locality",
                "district"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    5,
                    10
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    11,
                    14
                ],
                "lightness": 0,
                "color": "#FAF7F5"
            },
            {
                "zoom": [
                    15,
                    22
                ],
                "lightness": 0,
                "color": "#FCFAFA"
            }
        ]
    },
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "residential"
            ]
        },
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road"
            ]
        },
        "stylers": {
            "color": "#FCFAFA"
        }
    },
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "landscape"
            ],
            "none": [
                "land",
                "landcover"
            ]
        },
        "stylers": {
            "opacity": 0.4
        }
    },
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "poi"
            ],
            "none": [
                "park"
            ]
        },
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "types": "point",
        "elements": "label",
        "tags": {
            "any": [
                "admin",
                "landscape"
            ]
        },
        "stylers": {
            "scale": 0.85,
            "lightness": 0.1
        }
    },
    {
        "types": "point",
        "elements": "label",
        "tags": {
            "any": [
                "district"
            ]
        },
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "types": "polyline",
        "elements": "label.text",
        "tags": {
            "any": [
                "road"
            ]
        },
        "stylers": {
            "scale": 0.9,
            "lightness": 0.2
        }
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_1",
                "road_2"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    9
                ],
                "color": "#CFCFCF",
                "scale": 0.9
            },
            {
                "zoom": [
                    10,
                    22
                ],
                "color": "#E8E8E8",
                "scale": 0.9
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_1",
                "road_2"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    8
                ],
                "scale": 0.9
            },
            {
                "zoom": [
                    9,
                    11
                ],
                "color": "#D9D9D9",
                "scale": 0.9
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "color": "#CFCFCF",
                "scale": 0.9
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_3",
                "road_4"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    8
                ],
                "color": "#CFCFCF",
                "scale": 0.8
            },
            {
                "zoom": [
                    9
                ],
                "color": "#D9D9D9",
                "scale": 0.8
            },
            {
                "zoom": [
                    10,
                    11
                ],
                "color": "#E8E8E8",
                "scale": 0.6
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "color": "#E8E8E8",
                "scale": 0.9
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_3",
                "road_4"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    8
                ],
                "scale": 0.8
            },
            {
                "zoom": [
                    9
                ],
                "color": "#D9D9D9",
                "scale": 0.8
            },
            {
                "zoom": [
                    10,
                    11
                ],
                "color": "#D9D9D9",
                "scale": 0.6
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "color": "#CFCFCF",
                "scale": 0.9
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_5"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    10,
                    11
                ],
                "scale": 0.8,
                "color": "#D9D9D9"
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "scale": 0.7,
                "color": "#E8E8E8"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_5"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    10,
                    11
                ],
                "scale": 0.8,
                "color": "#D9D9D9"
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "scale": 0.7,
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_6"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    10,
                    12
                ],
                "scale": 0.8,
                "color": "#D9D9D9"
            },
            {
                "zoom": [
                    13,
                    22
                ],
                "scale": 0.7,
                "color": "#E8E8E8"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_6"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    10,
                    12
                ],
                "scale": 0.8
            },
            {
                "zoom": [
                    13,
                    22
                ],
                "scale": 0.7,
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_7",
                "road_limited"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    13
                ],
                "scale": 0.8,
                "color": "#D9D9D9"
            },
            {
                "zoom": [
                    14,
                    22
                ],
                "scale": 0.7,
                "color": "#ffffff"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_7",
                "road_limited"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    13
                ],
                "scale": 0.8
            },
            {
                "zoom": [
                    14,
                    22
                ],
                "scale": 0.7,
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_construction"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    13,
                    14
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    15,
                    22
                ],
                "scale": 0.7,
                "color": "#ffffff"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_construction"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    13,
                    14
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    15,
                    22
                ],
                "scale": 0.7,
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_unclassified"
            ]
        },
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_unclassified"
            ]
        },
        "stylers": [
            {
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "road_minor"
            ]
        },
        "stylers": [
            {
                "scale": 0.6,
                "color": "#ffffff"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "road_minor"
            ]
        },
        "stylers": [
            {
                "scale": 0.6,
                "color": "#CFCFCF"
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "path",
                "crosswalk"
            ],
            "none": [
                "structure"
            ]
        },
        "stylers": {
            "scale": 0.6,
            "lightness": -0.05
        }
    },
    {
        "types": "polyline",
        "elements": "geometry.outline",
        "tags": {
            "any": [
                "path",
                "crosswalk"
            ],
            "none": [
                "structure"
            ]
        },
        "stylers": {
            "scale": 0.6
        }
    },
    {
        "types": "polyline",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "transit_line"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    11
                ],
                "scale": 0.9,
                "saturation": 0.1
            },
            {
                "zoom": [
                    12,
                    22
                ],
                "scale": 1.2,
                "saturation": 0.1
            }
        ]
    },
    {
        "types": "polygon",
        "tags": {
            "any": [
                "building",
                "fence"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    14
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    15,
                    22
                ],
                "saturation": -0.5,
                "opacity": 0.7
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text",
        "tags": {
            "any": [
                "address"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    16
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    17,
                    22
                ],
                "scale": 0.9
            }
        ]
    },
    {
        "types": [
            "point",
            "polyline"
        ],
        "elements": "label.text.fill",
        "tags": {
            "any": [
                "water"
            ]
        },
        "stylers": {
            "scale": 0.8
        }
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "any": [
                "poi"
            ],
            "none": [
                "park"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    8,
                    12
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    13,
                    22
                ],
                "lightness": 0.1,
                "scale": 0.9,
                "saturation": -1
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text",
        "tags": {
            "any": [
                "poi"
            ],
            "none": [
                "park"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    8,
                    12
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    13,
                    22
                ],
                "lightness": 0.1,
                "scale": 0.9,
                "saturation": -1
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text",
        "tags": {
            "any": [
                "poi"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    17
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "any": [
                "poi"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    17
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text.fill",
        "tags": {
            "any": [
                "park"
            ],
            "none": [
                "poi"
            ]
        },
        "stylers": [
            {
                "lightness": 0,
                "scale": 0.9,
                "saturation": 0
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "all": [
                "transit_stop"
            ],
            "none": [
                "is_unclassified_transit"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    16
                ],
                "visibility": "off"
            },
            {
                "scale": 0.8
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text",
        "tags": {
            "all": [
                "transit_location"
            ],
            "none": [
                "is_unclassified_transit"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    14
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "all": [
                "transit_stop"
            ],
            "none": [
                "is_unclassified_transit"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    12
                ],
                "visibility": "off"
            },
            {
                "zoom": [
                    17
                ],
                "scale": 1.4
            },
            {
                "zoom": [
                    18,
                    22
                ],
                "scale": 1.11
            }
        ]
    },
    {
        "types": "polyline",
        "elements": "geometry",
        "tags": {
            "any": [
                "transit_schema"
            ]
        },
        "stylers": {
            "scale": 1.6,
            "opacity": 1,
            "saturation": 0.1
        }
    },
    {
        "types": "polygon",
        "elements": "geometry.fill",
        "tags": {
            "any": [
                "structure"
            ],
            "none": [
                "building"
            ]
        },
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "types": "polyline",
        "tags": {
            "any": [
                "transit_schema"
            ]
        },
        "stylers": {
            "visibility": "off"
        }
    },
    {
        "types": "polyline",
        "elements": "geometry",
        "tags": {
            "any": [
                "transit_line"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    1,
                    13
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "all": [
                "transit_location"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    12
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.text",
        "tags": {
            "all": [
                "transit_location"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    12
                ],
                "visibility": "off"
            }
        ]
    },
    {
        "types": "point",
        "elements": "label.icon",
        "tags": {
            "all": [
                "transit_location"
            ]
        },
        "stylers": [
            {
                "zoom": [
                    0,
                    14
                ],
                "scale": 0.7
            }
        ]
    },
    {
        "types": "polygon",
        "elements": "geometry",
        "tags": {
            "all": [
                "park"
            ]
        },
        "stylers": [
            {
                "color": "#DFE5D4"
            }
        ]
    },
    {
        "types": "polygon",
        "elements": "geometry",
        "tags": {
            "all": [
                "landcover"
            ]
        },
        "stylers": [
            {
                "color": "#DFE5D4"
            }
        ]
    },
    {
        "types": "polygon",
        "elements": "geometry",
        "tags": {
            "all": [
                "water"
            ]
        },
        "stylers": [
            {
                "color": "#CED9DF"
            }
        ]
    }
];
